export const socials = [
  { label: 'Facebook', value: 'facebook' },
  { label: 'Twitter', value: 'twitter' },
  { label: 'Linkedin', value: 'linkedin' },
  { label: 'Slack', value: 'slack' },
  { label: 'GitHub', value: 'github' },
  { label: 'Portfolio', value: 'portfolio' },
];
